module.exports = __webpack_public_path__ + "static/img/4-en.b557140.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/title-level/img/4-en.png
// module id = LPxX
// module chunks = 1